import React from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { FormValues } from 'components/Dashboards/Reporting/ReportSettingsModal/ReportSettingsModal.types';
import { ALL_USERS_ACCESS_WARNING } from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/ReportAccessSettings.consts';
import classes from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/ReportAccessSettings.module.scss';
import { Alert } from 'components/DesignSystem/Alert';
import { Switch } from 'components/DesignSystem/Switch';

export const AllUsersAccess = () => {
    // form context
    const { setValue, control } = useFormContext<FormValues>();
    const isNotifyAllOnUpload = useWatch({ control, name: 'notifyAllUsersOnUpload' });

    return (
        <>
            <div className={classes.notifySwitch}>
                <Switch
                    onChange={(event) => {
                        const isNotifyAllOnNewUpload = event.target.checked;
                        setValue('notifyAllUsersOnUpload', isNotifyAllOnNewUpload, {
                            shouldDirty: true,
                            shouldTouch: true,
                        });
                    }}
                    checked={isNotifyAllOnUpload}
                    label={'Notify users on new schedule upload?'}
                    labelPlacement={'start'}
                />
            </div>
            <Alert severity={'info'}>{ALL_USERS_ACCESS_WARNING}</Alert>
        </>
    );
};
